import { Sensor, DeviceCollectionHistory } from "@/global/interface/device/sensor"
import "./index.less"
import { useEffect, useState } from "react"
import { addSensorCollectionHistory, getSensorCollectionBySensorId, updateSensor } from "@/api/device/sensor"
import { Spin } from "antd"
import { useParams } from "react-router"
import { getDateDetailName } from "@/global/utils/date-utils"

interface Iprops {
    sensor: Sensor,
    setSensor: (e) => void
}

export default function SensorCollectionPanel(props: Iprops) {

    const { sensor } = props

    const { projectId } = useParams()

    const [collectionList, setCollectionList] = useState<DeviceCollectionHistory[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (!sensor) return
        generateData()
    }, [sensor])

    const generateData = () => {
        getSensorCollectionBySensorId(sensor.id).then(res => {
            let resList: DeviceCollectionHistory[] = res?.data || []
            setCollectionList(resList)
        })
    }

    // 修改设备运行状态
    const onDeviceRunStatusChange = () => {
        if (!sensor) return
        setLoading(true)
        if (sensor?.start) {
            console.log('sensor', sensor)
            // 切换为关闭
            updateSensor(sensor.id, { start: false }).then(res => {
                sensor.start = false
                props.setSensor({ ...sensor })
                // 添加记录
                return addSensorCollectionHistory(Number(projectId), sensor.id, { personName: "用户", start: false })
            }).finally(() => {
                setLoading(false)
                generateData()
            })
        } else {
            console.log('sensor', sensor)
            // 开启
            updateSensor(sensor.id, { start: true }).then(res => {
                sensor.start = true
                props.setSensor({ ...sensor })
                return addSensorCollectionHistory(Number(projectId), sensor.id, { personName: "用户", start: true })
            }).finally(() => {
                setLoading(false)
                generateData()
            })
        }
    }


    return (
        <div className="collection-main">
            <div className="title">
                采集
            </div>
            <div className="collection-list">
                {collectionList?.map((item, index) => (
                    <div className="list-item" key={index}>
                        <div className="label">
                            {"采集记录" + (index + 1)}
                        </div>
                        <div className="value">
                            {getDateDetailName(item.startTime) + " " + (item?.personName || "用户") + "对" + sensor?.name + "进行了 " + (item?.start ? "启动" : "停止") + " 采集"}
                        </div>
                    </div>
                ))}

            </div>
            <div className="btn-area">
                {loading ? (
                    <Spin />
                ) : (
                    <>
                        {sensor?.start ? (
                            <div className="stop-btn" onClick={() => { onDeviceRunStatusChange() }}>
                                停止采集
                            </div>
                        ) : (
                            <div className="check-btn" onClick={() => { onDeviceRunStatusChange() }}>
                                启动采集
                            </div>
                        )}
                    </>
                )}


            </div>
        </div>
    )
}